export { ENABLE_ANALYTICS } from "~/lib/env.shared";

// AIDEV-NOTE: Shared between client-side PageViewTracker and server-side page-view module.
// Keep in sync if modifying.
export const EXCLUDED_PAGE_VIEW_PATH_PREFIXES = [
    "/api/",
    "/healthz",
    "/_",
    "/favicon",
    "/fonts/",
    "/images/",
    "/assets/",
];

const importMetaEnv =
    (typeof import.meta !== "undefined" &&
        (import.meta as { env?: Record<string, string | undefined> }).env) ||
    {};

// AIDEV-NOTE: Ensure constants work in Node (no import.meta.env) and Vite builds.
const VERCEL_URL =
    typeof __VITE_VERCEL_URL__ !== "undefined"
        ? __VITE_VERCEL_URL__
        : importMetaEnv.VERCEL_URL || "";

export const SERVER_URL = VERCEL_URL
    ? `https://${VERCEL_URL}`
    : typeof window !== "undefined"
      ? window.location.origin
      : importMetaEnv.SERVER_URL || process.env.SERVER_URL || "";
export const API_URL = VERCEL_URL
    ? `https://${VERCEL_URL}/api`
    : SERVER_URL
      ? `${SERVER_URL}/api`
      : "https://staging.ifscompanion.org/api";

export const IS_PRODUCTION =
    typeof window !== "undefined" && window.location.hostname.includes("app");
